import React from 'react';
import { Container } from 'react-bootstrap';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useStores } from '../../hooks/use-stores';
import { starFishColor } from '../../components/styles';

const useStyles = makeStyles((theme) => ({
    walletContent: {
        '& a': {
            ...starFishColor(theme, 'color'),
            textDecoration: 'none',
            '&:hover': {
                textDecoration: 'underline',
            },
        },
    },
}));

const LearnAboutWallet = ({ notOnStarfish }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { authStore } = useStores();
    return (
        <Container>
            <h1>{notOnStarfish ? t('starfish:learnAboutWallet.nonStarfishWallet') : t('starfish:learnAboutWallet.wallet')}</h1>
            <div className={classes.walletContent} dangerouslySetInnerHTML={{ __html: authStore?.currentUser?.country == 'CA' ? t('starfish:learnAboutWallet.CA') : t('starfish:learnAboutWallet.US') }} />
        </Container >
    )
}

export default LearnAboutWallet;